export function isMobileDevice() {
    const userAgent = window.navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}

export function isWeChatBrowser() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('micromessenger') !== -1) {
        return true
    }
    return false
}